import { render, staticRenderFns } from "./AddMedicineModal.vue?vue&type=template&id=50ac2fd6&"
import script from "./AddMedicineModal.vue?vue&type=script&lang=js&"
export * from "./AddMedicineModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports